import React from 'react';
import createReactContext from '../context';
var context = createReactContext(undefined); // eslint-disable-next-line

export var Provider = context.Provider;

var consumer = function consumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, null, function (value) {
        var mp = Object.assign({}, props, value && props.absolute === undefined && {
          absolute: true
        });
        return (
          /*#__PURE__*/
          React.createElement(Origin, mp)
        );
      })
    );
  };
};

export default consumer;